<modal-title class="modal-title-v2" [title]="modalTitle | translate" />
<mat-dialog-content>
  <contact-exists-info [form]="form" [isInited]="true" #contactExistsInfoComponent />

  <form [formGroup]="form" class="mt-2">
    <ng-select
      [clearable]="false"
      [searchable]="false"
      bindValue="id"
      [items]="contactTypeList"
      [notFoundText]="'Contacts.Manage.notFoundText' | translate"
      class="new-select w-100 mb-3"
      [placeholder]="'Contacts.Fields.contactType' | translate"
      [formControlName]="NEW_CONTACT_FORM.type"
    />

    <div *ngIf="isCompany" class="row mb-3">
      <div class="col-12">
        <input-label [label]="'Contacts.Fields.companyName' | translate" [required]="true" />
        <input-v2
          [formControlName]="NEW_CONTACT_FORM.companyName"
          [placeholder]="'Contacts.Fields.companyName' | translate"
          [errMessages]="errorMessages(NEW_CONTACT_FORM.companyName)"
        />
      </div>
    </div>

    <div *ngIf="!isCompany" class="row mb-3">
      <div class="col-6">
        <input-label [label]="'Contacts.Manage.Personal.name' | translate" [required]="true" />
        <input-v2
          [formControlName]="NEW_CONTACT_FORM.firstName"
          [placeholder]="'Contacts.Manage.Personal.name' | translate"
          [errMessages]="errorMessages(NEW_CONTACT_FORM.firstName)"
        />
      </div>

      <div class="col-6">
        <input-label [label]="'Contacts.Manage.Personal.lastName' | translate" [required]="true" />
        <input-v2
          [formControlName]="NEW_CONTACT_FORM.lastName"
          [placeholder]="'Contacts.Manage.Personal.lastName' | translate"
          [errMessages]="errorMessages(NEW_CONTACT_FORM.lastName)"
        />
      </div>
    </div>

    <div class="mb-3">
      <ng-select
        ngSelectExtension
        class="w-100 new-select"
        [url]="CONFIG.API + '/tag/type?type=acquisition-source'"
        [placeholder]="'Contacts.Fields.contactSource' | translate"
        [notFoundText]="'Contacts.Manage.notFoundSource' | translate"
        [addTagText]="'Contacts.Manage.addContactSource' | translate"
        [formControlName]="NEW_CONTACT_FORM.acquisitionSource"
        [bindLabel]="'name'"
        [bindValue]="'name'"
        [addTag]="true"
        [tabIndex]="-1"
        [translateLabelPrefix]="'Contacts.Source.'"
        [inputAttrs]="{ maxlength: '255' }"
      />
    </div>

    <div class="mb-3">
      <input-label [label]="'Contacts.Fields.availability' | translate" />
      <input-v2
        [formControlName]="NEW_CONTACT_FORM.availability"
        [placeholder]="'Contacts.Fields.availability' | translate"
      />
    </div>

    <div class="mb-3">
      <input-label [label]="'Contacts.Manage.phone' | translate" />
      <phone-input-v2
        [form]="form"
        [phoneFlagName]="NEW_CONTACT_FORM.phoneCountry"
        [phoneName]="NEW_CONTACT_FORM.phone"
        [inputPlaceholder]="'Contacts.Manage.phone' | translate"
      />
    </div>

    <div class="mb-3">
      <input-label [label]="'Contacts.Fields.email' | translate" />
      <input-v2
        [formControlName]="NEW_CONTACT_FORM.email"
        [placeholder]="'Contacts.Fields.email' | translate"
        [errMessages]="errorMessages(NEW_CONTACT_FORM.email)"
      />
    </div>

    <div class="mb-4">
      <ng-select
        ngSelectExtension
        class="w-100 new-select"
        dropdownPosition="top"
        [url]="CONFIG.API + '/tag/type?type=contact-function'"
        [formControlName]="NEW_CONTACT_FORM.functions"
        [placeholder]="'Contacts.Manage.contactFunction' | translate"
        [notFoundText]="'Contacts.Manage.notFoundFunction' | translate"
        bindLabel="name"
        bindValue="name"
        [multiple]="true"
        [tabIndex]="-1"
        [translateLabelPrefix]="'Contacts.Function.'"
      />
    </div>

    @if (!data?.hideResponsible && !data.parentContact) {
      <div class="mb-3">
        <new-toggle-checkbox-v2
          [formControlName]="NEW_CONTACT_FORM.isResponsible"
          [label]="'Projects.useResponsibleContact' | translate"
        />
      </div>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <app-button
    (onClick)="cancel()"
    [class]="'mr-2 bold'"
    [config]="{
      text: 'Contacts.Preview.cancel' | translate,
      type: ButtonTypes.NEW_SECONDARY_BLUE,
      size: ButtonSize.LARGE
    }"
  />

  <app-button
    [disabled]="loading"
    [loading]="loading"
    (onClick)="submitContact()"
    [config]="{
      text: 'Contacts.Preview.saveContactPerson' | translate,
      type: ButtonTypes.NEW_PRIMARY_BLUE,
      size: ButtonSize.LARGE,
      prependSrc: './assets/img/ic-save.svg'
    }"
  />
</mat-dialog-actions>
